
import lnkAuditTrail from './lnk-audit-trail';

lnkAuditTrail.createService = function () {
    const app = new Vue(lnkAuditTrail).$mount();
    const http = Vue.prototype.$http;
    return {
        async openDialog(id, tableCode){
            if(!id || !tableCode){
                console.error('id and tableCode is required!');
                return;
            }
            try {
                var baseRows = await this.fetchRows(id, tableCode);
                var {fields, rows} = this.getFormattedData(baseRows);
                app.tableFields = fields;
                app.isVisible = true;
                app.$nextTick(() => {
                    app.tableRows = rows;
                });

            }catch (e) {
                this.$nav.error(e);
            }
        },
        async fetchRows(id, tableCode){
            var rows = [];
            const url = `${LinkVue.prefixUrl}/trackDisplay/queryByExamplePage`;
            const params = {
                filtersRaw: JSON.stringify([
                    {id: 'updObjId', property: 'updObjId', value: id},
                    {id: 'updObjCode', property: 'updObjCode', value: tableCode}
                ]),
                pageFlag: false,
                sort: 'created',
                order: 'desc'
            };
            try {
                const resp = await http.post(url, params, true);
                rows = resp.rows;
            }catch (e) {}
            return rows;
        },
        getFormattedData(rows){
            var result = [];
            var rows = rows || [];
            var fields = [];
            var fieldNames = [];
            var convertedRows = [];

            function getConvertedRow(row){
                var matchItem = null;
                for(var i in convertedRows){
                    var item = convertedRows[i];
                    if(row.batchNum && item.batchNum === row.batchNum){
                        matchItem = item;
                        break;
                    }
                }
                return matchItem;
            };
            rows.forEach((row) => {
                var field ={
                    label: row.fieldName,
                    newField: `new${row.fieldValue}`,
                    oldField: `old${row.fieldValue}`
                };
                if(row.fieldValue && fieldNames.indexOf(row.fieldValue)<0){
                    fields.push(field);
                    fieldNames.push(row.fieldValue);
                }
                var newRow = getConvertedRow(row);
                if(newRow!==null){
                    newRow[field.newField] = row.displayInfo;
                    newRow[field.oldField] = row.displayBeforeInfo;
                }else{
                    row[field.newField] = row.displayInfo;
                    row[field.oldField] = row.displayBeforeInfo;
                    convertedRows.push(row);
                }
            });
            return {fields, rows: convertedRows};
        }
    };
};

export default lnkAuditTrail;
